import React, { useState, useEffect } from "react";
import CustomBox from "../../CustomComponents/CustomBox/CustomBox";
import CustomPaper from "../../CustomComponents/CustomPaper/CustomPaper";
import CustomCard from "../../CustomComponents/CustomCard/CustomCard";
import CustomButton from "../../CustomComponents/CustomButton/CustomButton";
import CustomTypography from "../../CustomComponents/CustomTypography/CustomTypography";
import CustomCardContent from "../../CustomComponents/CustomCardContent/CustomCardContent";
import CustomPlayer from "../../CustomComponents/CustomPlayer/CustomPlayer";
import { useStyles } from "../../../assets/jss/ContentDetails";
import { updateContent } from "../../../services/ContentDetails";
import ErrorAlert from "../../ErrorAlert/ErrorAlert";
import CustomDivider from "../../CustomComponents/CustomDivider/CustomDivider";
import { ActionStatus, RBAC_CODE } from "../../../config/app-globals.enum";
import CustomCircularProgress from "../../CustomComponents/CustomCircularProgress/CustomCircularProgress";
import { getUserRBAC } from "../../../services/LocalStorageService";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export default function VideoComponent(props) {
    const params = useParams();

    const { t } = useTranslation();
    const classes = useStyles();
    const [getRBAC_ContentView] = React.useState(
        getUserRBAC(RBAC_CODE.CONTENT_VIEW, props)
    );
    const [content, setContent] = useState(null);
    const [isApiFailed, setIsApiFailed] = useState(false);
    const [isBtnEnabled, setIsBtnEnabled] = useState(false);
    const [isMediaEnded, setIsMediaEnded] = useState(false);
    const [isApi, setIsApi] = useState(false);
    const [isContentCompleted, setIsContentCompleted] = useState(false);
    const [quote, setQuote] = useState(null);
    const [mediaDuration, setMediaDuration] = useState(null);
    const [mediaProgress, setMediaProgress] = useState(null);
    const [mediaSeekTo, setMediaSeekTo] = useState(null);
    const [mediaLoader, setMediaLoader] = useState(true);
    const [mediaPartition] = useState(parseInt(process.env.REACT_APP_VIDEO_PARTITION));
    const [mediaPartitionCounter, setMediaPartitionCounter] = useState(1);
    const [mobileTokenParam] = useState(props.mobileTokenParam);
    const [finishNoteTitle, setFinishNoteTitle] = useState(null);
    const [finishNote, setFinishNote] = useState(null);

    useEffect(() => {
        if (props.content) {
            setContent(props.content);
        }
    }, [props.content]);

    useEffect(() => {
        if ((mediaProgress && mediaProgress.playedSeconds && mediaDuration > 0) || isMediaEnded) {
            if (
                (mediaPartitionCounter <= mediaPartition &&
                    (mediaDuration / mediaPartition) * mediaPartitionCounter <
                    mediaProgress.playedSeconds) || isMediaEnded
            ) {
                const counter = mediaPartitionCounter + 1;
                setMediaPartitionCounter(counter);
                if (mediaProgress.playedSeconds > Math.floor((mediaDuration * content.contentCompletedPercentage) / 100)) {
                    updateContentProgress(
                        isMediaEnded ? 100 : (mediaProgress.playedSeconds / mediaDuration) * 100,
                        (mediaPartitionCounter === mediaPartition) || isMediaEnded
                    );
                }
            }
        }
    }, [mediaProgress, isMediaEnded]);

    useEffect(() => {
        if (mediaDuration && content.contentCompletedPercentage) {
            setMediaSeekTo(
                Math.floor((mediaDuration * content.contentCompletedPercentage) / 100)
            );
        }
    }, [mediaDuration]);

    const [statusValue, setStatusValue] = React.useState();
    const [alertMessage, setAlertMessage] = React.useState("");
    const [isAlertOpen, setIsAlertOpen] = React.useState(false);

    const changeApiStatusCodeFunc = (status) => {
        if (status.code && status.code !== 0 && status.code !== 200) {
            setStatusValue(status.code);
            setAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setIsAlertOpen(true);
        }
    };

    const updateContentProgress = async (
        contentCompletedPercentage,
        isFinish
    ) => {
        if (content) {
            setIsApi(true);
            setAlertMessage("");
            setIsAlertOpen(false);
            const data = await updateContent({
                contentId: content._id,
                contentTypeId: content.contentTypeId,
                contentCompletedPercentage: contentCompletedPercentage,
                isFinish: isFinish,
                mobileToken: mobileTokenParam,
            }, params);
            if (
                data &&
                (data.status.code === 0 ||
                    data.status.code === 200 ||
                    data.status.code === 201)
            ) {
                setIsApi(false);
                setIsApiFailed(false);
                if (isFinish) {
                    setFinishNoteTitle(
                        data.content.finishNoteTitle ? data.content.finishNoteTitle : null
                    );
                    setFinishNote(
                        data.content.finishNote ? data.content.finishNote : null
                    );
                }
            } else {
                setIsApi(false);
                setIsApiFailed(true);
                changeApiStatusCodeFunc(data.status);
            }
        }
    };

    return (
        <>
            <CustomPaper elevation={0}>
                <CustomCard elevation={0} className={classes.cardContentWrapper}>
                    <CustomCardContent className={classes.cardContent}>
                        {content && !isContentCompleted ? (
                            <>
                                <CustomBox className={classes.cardContentBody}>
                                    {content.title && (
                                        <CustomTypography
                                            component="h3"
                                            variant="h3"
                                            className={classes.headerTitle}
                                        >
                                            {content.title}
                                        </CustomTypography>
                                    )}
                                    {content.contentPath && (
                                        <>
                                            <CustomBox className={classes.mediaWrapper}>
                                                {mediaLoader ? (
                                                    <CustomCircularProgress
                                                        className={classes.mediaWrapperLoader}
                                                    />
                                                ) : null}
                                                <CustomPlayer
                                                    className={classes.praisoPlayer}
                                                    onReady={() => setMediaLoader(false)}
                                                    // seekTo={mediaSeekTo}
                                                    onEnded={() => setIsMediaEnded(true)}
                                                    onDuration={(duration) => setMediaDuration(duration)}
                                                    onProgress={(progress) => setMediaProgress(progress)}
                                                    controls={true}
                                                    config={{
                                                        vimeo: {
                                                            responsive: true,
                                                            pip: true
                                                        },
                                                    }}
                                                    url={content.contentPath}

                                                // url="https://vimeo.com/180293809"
                                                />
                                            </CustomBox>
                                        </>
                                    )}
                                </CustomBox>
                                {/* getRBAC_ContentView &&
                getRBAC_ContentView.isUpdate === 1 */}
                                {content.actionStatus !== ActionStatus.COMPLETED &&
                                    content.actionStatus !== ActionStatus.EXPIRED ? (
                                    <>
                                        <CustomDivider className={classes.spacer} />
                                        <CustomBox
                                            mt={0}
                                            mb={2}
                                            className={classes.cardContentFooter}
                                        >
                                            <CustomTypography
                                                className={classes.actionLabel}
                                                component="h5"
                                                variant="h5"
                                            >
                                                {t("DONT_FORGET_TO_PRESS_PRESS_THE_NEXT_BUTTON_ONCE_YOU_HAVE_WATCHED_THE_VIDEO")}
                                            </CustomTypography>
                                            <CustomButton
                                                variant="contained"
                                                color="primary"
                                                className={classes.primaryButtonXl}
                                                disabled={!isMediaEnded}
                                                defaultrounded="true"
                                                onClick={() => setIsContentCompleted(true)}
                                            >
                                                {t("NEXT")}
                                            </CustomButton>
                                        </CustomBox>
                                    </>
                                ) : null}
                            </>
                        ) : null}
                        {isContentCompleted ? (
                            <>
                                <CustomBox className={classes.cardContentBody}>
                                    <CustomBox className={classes.completeMessage}>
                                        {finishNoteTitle && (
                                            <CustomTypography
                                                component="h5"
                                                className={classes.completeMessageTitle}
                                                dangerouslySetInnerHTML={{
                                                    __html: finishNoteTitle,
                                                }}
                                            />
                                        )}
                                        {finishNote && (
                                            <CustomTypography
                                                component="p"
                                                className={classes.completeMessageDesc}
                                                dangerouslySetInnerHTML={{
                                                    __html: finishNote,
                                                }}
                                            />
                                        )}
                                    </CustomBox>
                                </CustomBox>
                            </>
                        ) : null}
                    </CustomCardContent>
                </CustomCard>
            </CustomPaper>
            <ErrorAlert
                code={statusValue}
                message={alertMessage}
                isOpen={isAlertOpen}
                isClose={(isClose) => setIsAlertOpen(!isClose)}
            />
        </>
    );
}
